import { Spinner } from "@/components/ui/custom/spinner"

export function PageLoader() {
  return (
    <div className="grid min-h-screen w-full place-items-center">
      <div className="flex flex-col items-center gap-2">
        <Spinner variant="default" size={48} />
        <span className="text-lg text-muted-foreground">Loading</span>
      </div>
    </div>
  )
}
